export default __webpack_public_path__ + "static/media/plus.76a1061d.svg";